import React from 'react';

import ConfigProvider from '../config/ConfigProvider';
import { Additional3dsInfo, Environment, Locale, PaymentMethod, ShopBundle } from '../types';

import BraintreeAuthorizer from './CreditCard/Braintree/BraintreeAuthorizer';
import ErrorContextProvider from './ErrorContextProvider';
import I18nProvider from './I18nProvider';
import Providers from './Providers';
import SentryErrorBoundary from './SentryErrorBoundary';

export type PaymentAuthorizationSwitchProps = {
  errorContainerId: string;
  shopBundle: ShopBundle;
  domain: string;
  locale: Locale;
  currency: string;
  paymentMethod: PaymentMethod;
  pspToken: string;
  braintreeNonceToken: string;
  braintreeBinData?: string;
  braintreeBin: string;
  shouldUseSimpleBin: boolean;
  amount: number;
  additional3dsInfo?: Additional3dsInfo;
  env: Environment;
};

/**
 * Non-UI component which handles the authorization with Braintree.
 */
const PaymentAuthorizationSwitch: React.FC<PaymentAuthorizationSwitchProps> = ({
  errorContainerId,
  shopBundle,
  domain,
  locale,
  currency,
  paymentMethod,
  pspToken,
  braintreeNonceToken,
  braintreeBinData,
  braintreeBin,
  shouldUseSimpleBin,
  amount,
  additional3dsInfo,
  env,
}) => {
  const resolvedBin = shouldUseSimpleBin === true ? braintreeBin : (braintreeBinData as string);

  return (
    <ConfigProvider env={env} shopBundle={shopBundle}>
      <I18nProvider shopBundle={shopBundle} locale={locale}>
        <SentryErrorBoundary>
          <ErrorContextProvider errorContainerId={errorContainerId}>
            <Providers shopBundle={shopBundle} domain={domain} locale={locale}>
              {paymentMethod === 'BK' && (
                <BraintreeAuthorizer
                  token={pspToken}
                  nonce={braintreeNonceToken}
                  bin={resolvedBin}
                  amount={amount}
                  currency={currency}
                  additional3dsInfo={additional3dsInfo}
                />
              )}
            </Providers>
          </ErrorContextProvider>
        </SentryErrorBoundary>
      </I18nProvider>
    </ConfigProvider>
  );
};

export default PaymentAuthorizationSwitch;
